import styled, { css } from 'styled-components';

const selectedStyles = css`
  background-color: #e9eced;
  box-shadow:none;
`;

export const Button = styled.button`
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: bold;
  color: #58667e;
  cursor: pointer;
  border-radius: 4px;
  margin: 4px;

  &:hover {
    background-color: #f7f7f7;
  }

  &:active {
    background-color: #e9eced;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  ${props => props.selected && selectedStyles} 
`;

export const FromTrackReleaseButton = styled(Button)`
  border: none;
`;

export const AsOfTodayButton = styled(Button)`
  border: none;
`;

export const TimeRangeButton = styled(Button)`
  border: none;
  color: #58667e;
`;

export const ExportButton = styled(Button)`
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: bold;
  color: #58667e;
  cursor: pointer;
  border-radius: 4px;
  margin: 4px;

  &:hover {
    background-color: #f7f7f7;
  }

  &:active {
    background-color: #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

export const StyledSelect = styled.select`
  background-color: #fff;
  border: none;
  border-bottom: 2px solid #ddd; 
  border-color:black;
  padding-top: 8px;
  padding-left: 30px;
  padding-bottom:0;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  margin: 4px;
  width: 250px; 
  cursor:pointer;
  background-image: url(https://imgs.search.brave.com/8Gz7F697P_CEx248_M_WbRcKHP1I-NmrOGzoc1XzWWs/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy84/Lzg0L1Nwb3RpZnlf/aWNvbi5zdmc);
  background-size: 20px; 
  background-repeat: no-repeat;
  background-position: 3px center;
  
  

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

   option {
    font-size: 1rem;
    margin-right:5px;
  }
`;


